import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M16 15L19 12L16 9L15.293 9.707L17.086 11.5H5V12.5H17.086L15.293 14.293L16 15Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ThinLong02Right"
);
